export enum SAVE_BAR_STATUS {
  SUCCESS = "success",
  WARNING = "warning",
  DEFAULT = "default",
}
